<template>
  <limit-editor
    :service="lottoServiceInstance"
    :endpoint-config="endpointConfig"
    :preset-config="presetConfig"
  />
</template>

<script>
import request from '@/service/request'
import lottoService from '@/service/lottoService'
import LimitEditor from './components/LimitEditor.vue'

const createService = baseUrl => ({
  ...request,
  base_url: baseUrl,
})

const lottoV2ApiBase = process.env.VUE_APP_LOTTO_V2_API || lottoService.base_url

const endpointConfig = {
  fetchLimit: id => `LimitUser/${id}`,
  saveLimit: id => `LimitUser/${id}`,
  fetchAutoStatus: id => `LimitUser/auto/${id}`,
  toggleAuto: id => `LimitUser/toggle-auto/${id}`,
  broadcast: id => `LimitUser/broadcast/${id}`,
  downloadRaw: id => `LimitUser/load-raw/${id}`,
}

const presetConfig = {
  useService: true,
  loadPath: id => `LimitUser/${id}`,
}

export default {
  name: 'LottoLimitV2View',
  components: {
    LimitEditor,
  },
  data() {
    return {
      lottoServiceInstance: createService(lottoV2ApiBase),
      endpointConfig,
      presetConfig,
    }
  },
}
</script>
